const BASE_URL = '';
const ENVIRONMENT = 'PRODUCTION';
const ENABLE_REDUX_LOGGER = false;
const PUBLIC_DASHBOARD_DOMAIN_NAME = 'd2q4uttsgr4c0n.cloudfront.net'

export { ENVIRONMENT, BASE_URL, ENABLE_REDUX_LOGGER, PUBLIC_DASHBOARD_DOMAIN_NAME };